/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { Component, OnInit, ViewChild, ViewEncapsulation, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Icon } from '../../models/icon';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  providers: [
    BsModalRef,
    BsModalService
  ],
  encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit {

  Icon = Icon;
  @Input() strictClose: boolean;
  @Input() customClass: string;
  @Input() title: string;
  @Input() buttonText: string;
  @Input() isPrimaryButton = false;
  @Input() showButton = true;
  @Input() showCloseIcon = true;
  @Input() showDisclaimer = false;
  @Input() disclaimerText: string;
  @Input() noHeader: boolean;
  @Input() cropModal: boolean;
  @Input() adobestepname: string;
  @Input() adobestepclusterOptional: string;
  @Input() adobeSubmitTiggerClass = 'modal-ab-CTA';
  @Output() toggleModal: EventEmitter<string> = new EventEmitter<string>();
  @Output() modalClosed: EventEmitter<void> = new EventEmitter<void>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @ViewChild('appModalTemplate') appModalTemplate: TemplateRef<any>;
  private silModal: BsModalRef;
  constructor(
    private modalService: BsModalService
  ) { }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void { }

  openModal(): BsModalRef {
    return this.openAppModal(this.strictClose);
  }

  private openAppModal(isStrictClose: boolean): BsModalRef {
    const config = {
      // backdrop: 'static',
      keyboard: !isStrictClose,
      ignoreBackdropClick: isStrictClose,
      class: `sil-modal ${this.customClass}`
    } as ModalOptions;

    this.silModal = this.modalService.show(
      this.appModalTemplate,
      config
    );
    this.toggleModal.emit('open');
    return this.silModal;
  }

  closeModal(isCancel = false): void {
    this.silModal?.hide();
    this.modalClosed?.emit();
    this.toggleModal.emit(isCancel ? 'cancel' : 'ok');
  }
}
